type Props = {
  currentTab: number;
  content: Array<React.ReactNode>;
  className?: string;
  style?: React.CSSProperties;
  keepMounted?: boolean;
};
export const BlingsTabs = (props: Props) => {
  const { currentTab, content, className, style, keepMounted = false } = props;
  return (
    <div className={`BlingsTabs ${className || ""}`} style={style}>
      {keepMounted ? content : content[currentTab]}
    </div>
  );
};
